import { Routes } from '@angular/router';

import { DefaultRoutes } from './default.routes';

import { validTenantGuard } from '@core/guards';
import { Demo } from './features/demo/demo';


export const routes: Routes = [
  { path: DefaultRoutes.Empty, redirectTo: DefaultRoutes.Default, pathMatch: 'full' },
  {
    path: `${DefaultRoutes.TenantParam}/kiosk`,
    canActivate: [validTenantGuard()],
    loadChildren: () => import('./features/kiosk/kiosk.routes').then(m => m.kioskRoutes),
  },
  {
    path: `${DefaultRoutes.TenantParam}/admin`,
    canActivate: [validTenantGuard()],
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes),
  },
  {
    path: `${DefaultRoutes.TenantParam}/demo`,
    canActivate: [() => true],
    component: Demo,
  },
  { path: DefaultRoutes.Wildcard, redirectTo: DefaultRoutes.Default }
];